import Frame from "../../assets/framehoratiu.png";
import { teamSection } from "../../texts";
import "./styles.scss";
import { useEffect } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";

const Team = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    let hasPlayed = false;

    const animation = gsap
      .timeline({
        paused: true,
      })
      .to(".teamContainer", {
        opacity: 1,
        y: -100,
      });

    ScrollTrigger.create({
      trigger: "#team",
      start: "-20% 80%",
      end: "30% 90%",
      onEnter: () => {
        if (!hasPlayed) {
          animation.play();
          hasPlayed = true;
        }
      },
    });
  }, []);
  return (
    <section id="team">
      <div className="teamContainer">
        <div className="subheader">{teamSection.title1}</div>
        <div className="subheaderBigger">{teamSection.title2}</div>
        <p className="teamParagraph">{teamSection.paragraph1}</p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0,
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img className="frame" src={Frame} alt="frame" />
        </div>
      </div>
    </section>
  );
};

export default Team;
